var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9655 6.37H5.53714C3.68464 6.37 2.16797 7.88666 2.16797 9.73916V22.0458C2.16797 23.6167 3.29464 24.2883 4.67047 23.5192L8.92797 21.1467C9.38297 20.8975 10.1196 20.8975 10.5638 21.1467L14.8213 23.5192C16.208 24.2775 17.3346 23.6167 17.3346 22.0458V9.73916C17.3346 7.88666 15.818 6.37 13.9655 6.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8343 5.53579V17.8425C23.8343 19.4133 22.7076 20.0741 21.3318 19.3158L19.241 18.1458C19.0676 18.0483 18.9593 17.8641 18.9593 17.6691V9.73913C18.9593 6.98746 16.7168 4.74496 13.9651 4.74496H9.55597C9.15513 4.74496 8.87347 4.32246 9.05763 3.97579C9.62097 2.90329 10.7476 2.16663 12.0368 2.16663H20.4651C22.3176 2.16663 23.8343 3.68329 23.8343 5.53579Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave2);
export default __webpack_public_path__ + "static/media/save-2.280681c3df043dcaac93e1424d37c229.svg";
export { ForwardRef as ReactComponent };